export default function OutlinedTitle({
    className,
    children
}) {
    return(
        <div className={`${className}`}>
            {children}
            <div className="border border-primary-400 w-[80%] mt-4 mb-8"></div>
            <div className="border border-primary-400 w-[60%]"></div>
        </div>
    )
}